import { styled } from '@mui/system'
import { Box, type BoxProps } from '@mui/material'

interface TermHeaderContainerProps extends BoxProps {
  hasButton?: boolean
}

export const TermHeaderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasButton'
})<TermHeaderContainerProps>(({ theme, hasButton }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: hasButton ? 'initial' : 'end',
  width: '100%',
  flexWrap: 'nowrap',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    flexWrap: 'wrap'
  }
}))
